let filePondLib = null

export async function loadFilePond() {
  if (filePondLib) return filePondLib

  const [
    FilePondModule,
    FileEncode,
    ValidateType,
    ImagePreview,
    FilePoster,
    MediaPreview
  ] = await Promise.all([
    import("filepond"),
    import("filepond-plugin-file-encode"),
    import("filepond-plugin-file-validate-type"),
    import("filepond-plugin-image-preview"),
    import("filepond-plugin-file-poster"),
    import("filepond-plugin-media-preview")
  ])

  const FilePond = FilePondModule.default || FilePondModule

  FilePond.registerPlugin(
    FileEncode.default || FileEncode,
    ValidateType.default || ValidateType,
    ImagePreview.default || ImagePreview,
    FilePoster.default || FilePoster,
    MediaPreview.default || MediaPreview
  )

  filePondLib = FilePond
  return FilePond
}